/* SAMBA theme — theme.js (vanilla, sin dependencias) */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toLocaleString('es-CO'); }
  };

  /* ---------- Announcement bar ---------- */
  function initAnnouncement() {
    const bar = $('[data-announcement]');
    if (!bar) return;
    const slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    let i = 0;
    const show = (n) => { slides.forEach((s, k) => s.classList.toggle('is-active', k === n)); };
    const go = (d) => { i = (i + d + slides.length) % slides.length; show(i); };
    const prev = $('[data-ann-prev]', bar), next = $('[data-ann-next]', bar);
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    setInterval(() => go(1), 5000);
  }

  /* ---------- Hero slideshow ---------- */
  function initHero() {
    const hero = $('[data-hero]');
    if (!hero) return;
    const track = $('[data-hero-track]', hero);
    const slides = $$('.hero__slide', track);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    let i = 0, timer = null;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); restart(); }));
    const autoplay = hero.getAttribute('data-autoplay') === 'true';
    const interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
    const restart = () => { if (!autoplay) return; clearInterval(timer); timer = setInterval(() => go(i + 1), interval); };
    restart();
  }

  /* ---------- Gender toggle ---------- */
  function initGender() {
    $$('[data-gender-grid]').forEach((grid) => {
      const tabs = $$('[data-gender-tab]', grid);
      const panels = $$('[data-gender-panel]', grid);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        const idx = tab.getAttribute('data-gender-tab');
        tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
        panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-gender-panel') === idx));
      }));
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    $$('[data-carousel]').forEach((car) => {
      const vp = $('[data-carousel-viewport]', car);
      const prev = $('[data-carousel-prev]', car), next = $('[data-carousel-next]', car);
      if (!vp) return;
      const step = () => Math.max(vp.clientWidth * 0.8, 240);
      if (prev) prev.addEventListener('click', () => vp.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => vp.scrollBy({ left: step(), behavior: 'smooth' }));
      const update = () => {
        if (prev) prev.disabled = vp.scrollLeft <= 4;
        if (next) next.disabled = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 4;
      };
      vp.addEventListener('scroll', update); window.addEventListener('resize', update); update();
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const menu = $('[data-mobile-menu]'), overlay = $('[data-overlay]');
    const open = $('[data-menu-open]'), close = $('[data-menu-close]');
    if (!menu) return;
    const toggle = (state) => {
      menu.classList.toggle('is-open', state);
      if (overlay) overlay.classList.toggle('is-open', state);
      document.body.style.overflow = state ? 'hidden' : '';
    };
    if (open) open.addEventListener('click', () => toggle(true));
    if (close) close.addEventListener('click', () => toggle(false));
    if (overlay) overlay.addEventListener('click', () => { toggle(false); cartToggle(false); });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = () => $('[data-cart-drawer]');
  function cartToggle(state) {
    const d = drawer(), overlay = $('[data-overlay]');
    if (!d) return;
    d.classList.toggle('is-open', state);
    if (overlay) overlay.classList.toggle('is-open', state);
    document.body.style.overflow = state ? 'hidden' : '';
  }
  function renderCart(cart) {
    const items = $('[data-cart-items]'), foot = $('[data-cart-foot]'), empty = $('[data-cart-empty]'), sub = $('[data-cart-subtotal]');
    $$('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    if (!items) return;
    if (cart.item_count === 0) {
      items.innerHTML = ''; if (foot) foot.hidden = true; if (empty) empty.hidden = false;
      renderFreeShipping(cart); return;
    }
    if (foot) foot.hidden = false; if (empty) empty.hidden = true;
    items.innerHTML = cart.items.map((it, i) => (
      '<div class="cart-item" data-line="' + (i + 1) + '">' +
      '<a href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '&width=160" alt="">' : '') + '</a>' +
      '<div class="cart-item__info"><a href="' + it.url + '"><strong>' + it.product_title + '</strong></a>' +
      (it.variant_title && it.variant_title.indexOf('Default') === -1 ? '<div class="cart-item__variant">' + it.variant_title + '</div>' : '') +
      '<div class="cart-item__controls">' +
        '<div class="cart-qty">' +
          '<button type="button" class="cart-qty__btn" data-cart-minus aria-label="Quitar uno">−</button>' +
          '<span class="cart-qty__val">' + it.quantity + '</span>' +
          '<button type="button" class="cart-qty__btn" data-cart-plus aria-label="Agregar uno">+</button>' +
        '</div>' +
        '<button type="button" class="cart-item__remove" data-cart-remove>Quitar</button>' +
      '</div></div>' +
      '<div class="cart-item__price">' + money(it.final_line_price) + '</div></div>'
    )).join('');
    if (sub) sub.textContent = money(cart.total_price);
    renderFreeShipping(cart);
  }
  function renderFreeShipping(cart) {
    $$('[data-free-shipping]').forEach(function (bar) {
      const goal = parseInt(bar.getAttribute('data-goal'), 10);
      if (!goal) return;
      const total = cart.total_price;
      const remaining = goal - total;
      const pct = Math.min(100, Math.round((total * 100) / goal));
      const fill = $('[data-fsb-fill]', bar);
      const txt = $('[data-fsb-text]', bar);
      const track = $('.fsb__track', bar);
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', pct);
      bar.classList.toggle('is-complete', remaining <= 0);
      if (txt) {
        const icon = txt.querySelector('svg');
        txt.innerHTML = remaining <= 0
          ? '<strong>¡Tienes envío gratis!</strong>'
          : 'Te faltan <strong>' + money(remaining) + '</strong> para el envío gratis';
        if (icon) txt.insertBefore(icon, txt.firstChild);
      }
    });
  }
  function refreshCart(openIt) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.json()).then((c) => { renderCart(c); if (openIt) cartToggle(true); });
  }
  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then((r) => r.json()).then((c) => renderCart(c));
  }
  /* Complementos marcados en "Suelen llevarlo con" (se suman al agregar o comprar) */
  function lookItems() {
    const root = document.querySelector('[data-complete-look]');
    if (!root) return [];
    return $$('[data-clook-item]', root)
      .filter((it) => $('[data-clook-check]', it).checked)
      .map((it) => ({ id: Number($('[data-clook-variant]', it).value), quantity: 1 }))
      .filter((i) => i.id);
  }
  function clearLookChecks() {
    const root = document.querySelector('[data-complete-look]');
    if (!root) return;
    $$('[data-clook-check]', root).forEach((c) => { c.checked = false; });
    root.dispatchEvent(new CustomEvent('clook:sync'));
  }
  // producto principal + complementos marcados, en el formato de /cart/add.js
  function formItems(form) {
    const idEl = $('[data-variant-id]', form) || form.querySelector('[name="id"]');
    const qtyEl = $('[data-qty-input]', form) || form.querySelector('[name="quantity"]');
    const id = Number(idEl ? idEl.value : 0);
    const quantity = Math.max(1, parseInt(qtyEl ? qtyEl.value : '1', 10) || 1);
    return [{ id: id, quantity: quantity }].concat(lookItems());
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then((r) => r.json());
  }

  function initCart() {
    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); refreshCart(true); }
      if (e.target.closest('[data-cart-close]')) cartToggle(false);

      // Cantidad / eliminar dentro del drawer
      const minus = e.target.closest('[data-cart-minus]');
      const plus = e.target.closest('[data-cart-plus]');
      const remove = e.target.closest('[data-cart-remove]');
      if (minus || plus || remove) {
        const itemEl = e.target.closest('[data-line]');
        if (!itemEl) return;
        const line = parseInt(itemEl.getAttribute('data-line'), 10);
        const valEl = itemEl.querySelector('.cart-qty__val');
        const val = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
        if (remove) changeLine(line, 0);
        else if (plus) changeLine(line, val + 1);
        else if (minus) changeLine(line, Math.max(0, val - 1));
      }

      // Comprar ahora -> agrega y va directo al checkout
      const buyNow = e.target.closest('[data-buy-now]');
      if (buyNow) {
        e.preventDefault();
        const form = buyNow.closest('[data-product-root]') ? $('[data-product-form]', buyNow.closest('[data-product-root]')) : document.querySelector('[data-product-form]');
        if (!form) return;
        buyNow.disabled = true;
        const label = buyNow.textContent;
        buyNow.textContent = '...';
        addItems(formItems(form))
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { buyNow.disabled = false; buyNow.textContent = label; });
      }
    });
    // intercept add-to-cart forms
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      const btn = $('[data-atc]', form), txt = $('[data-atc-text]', form);
      const original = txt ? txt.textContent : '';
      if (txt) txt.textContent = '...';
      addItems(formItems(form))
        .then(() => { if (txt) txt.textContent = original; clearLookChecks(); refreshCart(true); })
        .catch(() => { if (txt) txt.textContent = original; });
    });
    refreshCart(false);
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    const root = $('[data-product-root]');
    if (!root) return;
    let variants = [];
    try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) {}

    const options = $$('[data-option-index]', root);
    const selected = [];
    options.forEach((o, idx) => {
      const active = $('[data-option-value].is-active', o);
      selected[idx] = active ? active.getAttribute('data-value') : null;
    });

    const thumbs = $$('[data-thumb]');
    const mainImgs = $$('.product__main-img', root);
    // Imágenes ya están en el DOM: cambiar = togglear visibilidad (instantáneo).
    const galleryWrap = $('[data-main-image]', root);
    const counterEl = $('[data-gallery-current]', root);
    const totalEl = $('[data-gallery-total]', root);
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const setCounter = (idx) => { if (counterEl) counterEl.textContent = idx + 1; };

    // Filtro de galería por variante. data-tags = "Horma1,Horma2|Color" (viene del alt
    // de la media, etiquetado por API). Sin etiqueta => la foto se muestra siempre.
    const optIdxByName = {};
    options.forEach((o, idx) => {
      optIdxByName[(o.getAttribute('data-option-name') || '').toLowerCase()] = idx;
    });
    const matchesSelection = (el, ignoreColor) => {
      const tag = (el.getAttribute('data-tags') || '').trim();
      if (!tag || tag.indexOf('|') === -1) return true;
      const hormas = tag.split('|')[0].split(',').map((s) => s.trim()).filter(Boolean);
      const color = tag.split('|')[1].trim();
      const selColor = optIdxByName.color != null ? selected[optIdxByName.color] : null;
      const selHorma = optIdxByName.horma != null ? selected[optIdxByName.horma] : null;
      if (!ignoreColor && selColor && color && color !== selColor) return false;
      if (selHorma && hormas.length && hormas.indexOf(selHorma) === -1) return false;
      return true;
    };
    const visibleImgs = () => mainImgs.filter((im) => !im.classList.contains('is-hidden'));
    const applyGalleryFilter = () => {
      // Filtra solo por horma: se ven las fotos de esa horma en los 3 colores
      // (al elegir color, showMedia salta a la foto de ese color). Si la horma
      // no tiene fotos etiquetadas, se muestra todo.
      let pass = (el) => matchesSelection(el, true);
      if (!mainImgs.some(pass)) pass = () => true;
      mainImgs.forEach((im) => im.classList.toggle('is-hidden', !pass(im)));
      thumbs.forEach((t) => t.classList.toggle('is-hidden', !pass(t)));
      if (totalEl) totalEl.textContent = visibleImgs().length;
    };
    // Etiqueta flotante con horma y color de la foto activa.
    const labelEl = $('[data-gallery-label]', root);
    const setLabel = (im) => {
      if (!labelEl) return;
      const tag = im ? (im.getAttribute('data-tags') || '').trim() : '';
      if (!tag || tag.indexOf('|') === -1) { labelEl.style.display = 'none'; return; }
      labelEl.textContent = tag.split('|')[0].split(',').join(' / ') + ' · ' + tag.split('|')[1];
      labelEl.style.display = 'block';
    };
    const markById = (id) => {
      thumbs.forEach((x) => {
        const match = String(x.getAttribute('data-media-id')) === String(id);
        x.classList.toggle('is-active', match);
        // La columna de thumbs tiene scroll interno: mantener el activo a la vista.
        if (match && !isMobile()) x.scrollIntoView({ block: 'nearest' });
      });
    };
    const showMedia = (id) => {
      let matchImg = null;
      mainImgs.forEach((im) => {
        const match = String(im.getAttribute('data-media-id')) === String(id);
        im.classList.toggle('is-active', match);
        if (match) matchImg = im;
      });
      // El índice del contador/carrusel se calcula sobre las imágenes visibles (filtradas).
      const matchIdx = matchImg ? Math.max(0, visibleImgs().indexOf(matchImg)) : 0;
      markById(id);
      setCounter(matchIdx);
      setLabel(matchImg);
      // En móvil la galería es un carrusel: desplazar a la imagen activa (instantáneo y fiable).
      if (matchImg && galleryWrap && isMobile()) {
        galleryWrap.scrollLeft = matchIdx * galleryWrap.clientWidth;
      }
      return !!matchImg;
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.getAttribute('data-media-id'))));
    // Al hacer swipe en móvil, marcar thumbnail + actualizar contador.
    if (galleryWrap) {
      galleryWrap.addEventListener('scroll', () => {
        if (!isMobile() || !galleryWrap.clientWidth) return;
        const idx = Math.round(galleryWrap.scrollLeft / galleryWrap.clientWidth);
        const im = visibleImgs()[idx];
        if (im) { markById(im.getAttribute('data-media-id')); setCounter(idx); setLabel(im); }
      });
    }
    // Precargar todas las imágenes para que el cambio sea instantáneo.
    mainImgs.forEach((im) => { if (im.src) { const pre = new Image(); pre.src = im.src; } });

    // Barra sticky de Agregar al carrito (móvil).
    const stickyBar = $('[data-sticky-atc]');
    const atcBtnEl = $('[data-atc]', root);
    if (stickyBar && atcBtnEl && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc');
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { stickyBar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -5% 0px' });
      io.observe(atcBtnEl);
    }

    function findVariant() {
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    }
    function update() {
      const v = findVariant();
      const idInput = $('[data-variant-id]', root);
      const priceEl = $('[data-price]', root);
      const atc = $('[data-atc]', root), atcText = $('[data-atc-text]', root);
      applyGalleryFilter();
      if (!v) { if (atc) { atc.disabled = true; } if (atcText) atcText.textContent = 'No disponible'; showFirstVisible(); return; }
      if (idInput) idInput.value = v.id;
      var priceHtml = (v.compare_at_price && v.compare_at_price > v.price)
        ? '<span class="price__compare">' + money(v.compare_at_price) + '</span> <span class="price__sale">' + money(v.price) + '</span>'
        : money(v.price);
      if (priceEl) priceEl.innerHTML = priceHtml;
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = priceHtml;
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? (window.SAMBA_T_ADD || 'Agregar al carrito') : 'Agotado';
      // mostrar la imagen de la variante (ya está en el DOM => instantáneo)
      var fmId = v.featured_media ? v.featured_media.id : null;
      var fmImg = fmId ? mainImgs.find((im) => String(im.getAttribute('data-media-id')) === String(fmId)) : null;
      if (fmImg && !fmImg.classList.contains('is-hidden')) { showMedia(fmId); } else { showFirstVisible(); }
      const quotaEl = $('[data-financing-quota]');
      if (quotaEl) {
        const n = parseInt(quotaEl.getAttribute('data-installments'), 10) || 4;
        quotaEl.textContent = money(Math.round(v.price / n));
      }
    }
    function showFirstVisible() {
      const vis = visibleImgs();
      const active = vis.find((im) => im.classList.contains('is-active'));
      const target = active || vis[0];
      if (target) showMedia(target.getAttribute('data-media-id'));
    }
    // quantity stepper
    const qtyInput = $('[data-qty-input]', root);
    const qMinus = $('[data-qty-minus]', root), qPlus = $('[data-qty-plus]', root);
    if (qtyInput) {
      if (qMinus) qMinus.addEventListener('click', () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      if (qPlus) qPlus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    $$('[data-option-value]', root).forEach((btn) => btn.addEventListener('click', () => {
      const pos = parseInt(btn.getAttribute('data-option-position'), 10);
      const group = btn.closest('[data-option-index]');
      $$('[data-option-value]', group).forEach((b) => b.classList.toggle('is-active', b === btn));
      const label = $('[data-option-selected]', group);
      if (label) label.textContent = btn.getAttribute('data-value');
      selected[pos] = btn.getAttribute('data-value');
      update();
    }));
    update();
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    const sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Swatches en tarjetas de producto ---------- */
  function initCardSwatches() {
    $$('[data-product-card]').forEach((card) => {
      const img = $('.product-card__img--main', card);
      const swatches = $$('.swatch[data-swatch-img]', card);
      if (!img || !swatches.length) return;
      const original = img.getAttribute('src');
      swatches.forEach((sw) => {
        const apply = () => {
          const url = sw.getAttribute('data-swatch-img');
          if (!url) return;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = url;
          img.classList.remove('has-second'); // evita que el hover muestre otra foto
          $$('.swatch', card).forEach((s) => s.classList.toggle('is-active', s === sw));
        };
        sw.addEventListener('click', function (e) { e.preventDefault(); apply(); });
        sw.addEventListener('mouseenter', apply);
      });
    });
  }

  /* ---------- Línea de tiempo de entrega ---------- */
  function initDelivery() {
    const root = $('[data-delivery]');
    if (!root) return;
    const MES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
    const num = (k, d) => parseInt(root.getAttribute(k), 10) || d;
    const cutoff = num('data-cutoff', 16);
    const shipMin = num('data-ship-min', 4), shipMax = num('data-ship-max', 6);
    const delMin = num('data-deliver-min', 7), delMax = num('data-deliver-max', 9);

    // "ahora" en hora de Colombia (UTC-5), sin depender de la zona del visitante
    function nowCO() {
      const d = new Date();
      return new Date(d.getTime() + (d.getTimezoneOffset() * 60000) - (5 * 3600000));
    }
    // suma días hábiles saltando domingos
    function addDays(base, days) {
      const d = new Date(base.getTime());
      let left = days;
      while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) left--; }
      return d;
    }
    const fmt = (d) => d.getDate() + ' de ' + MES[d.getMonth()];
    function range(a, b) {
      if (fmt(a) === fmt(b)) return fmt(a);
      // mismo mes: "26 - 28 de agosto"; meses distintos: "29 de agosto - 1 de septiembre"
      if (a.getMonth() === b.getMonth()) return a.getDate() + ' - ' + fmt(b);
      return fmt(a) + ' - ' + fmt(b);
    }

    function render() {
      const now = nowCO();
      const deadline = new Date(now.getTime());
      deadline.setHours(cutoff, 0, 0, 0);
      // pasada la hora de corte, el pedido sale al día siguiente
      let base = new Date(now.getTime());
      if (now >= deadline) { deadline.setDate(deadline.getDate() + 1); base.setDate(base.getDate() + 1); }

      const ms = deadline - now;
      const h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
      const cd = $('[data-delivery-countdown]', root);
      if (cd) cd.textContent = (h > 0 ? String(h).padStart(2, '0') + ' h ' : '') + String(m).padStart(2, '0') + ' min';

      const orderEl = $('[data-delivery-order]', root);
      if (orderEl) orderEl.textContent = 'Hoy';
      const shipEl = $('[data-delivery-ship]', root);
      if (shipEl) shipEl.textContent = range(addDays(base, shipMin), addDays(base, shipMax));
      const delEl = $('[data-delivery-deliver]', root);
      if (delEl) delEl.textContent = range(addDays(base, delMin), addDays(base, delMax));
    }
    render();
    setInterval(render, 30000);
  }

  /* ---------- Consigue el look ---------- */
  function initCompleteLook() {
    const root = $('[data-complete-look]');
    if (!root) return;
    const items = $$('[data-clook-item]', root);
    const btn = $('[data-clook-add]', root), btnText = $('[data-clook-add-text]', root);

    function selected() {
      return items.filter((it) => $('[data-clook-check]', it).checked);
    }
    function sync() {
      const n = selected().length;
      btn.disabled = n === 0;
      btnText.textContent = n === 0 ? 'Selecciona un producto'
        : 'Agregar ' + n + (n === 1 ? ' producto' : ' productos') + ' al carrito';
    }
    items.forEach((it) => {
      $('[data-clook-check]', it).addEventListener('change', sync);
      // el label envuelve todo: evita que el select o el enlace marquen el checkbox
      const sel = $('[data-clook-variant]', it);
      if (sel && sel.tagName === 'SELECT') {
        sel.addEventListener('click', (e) => e.stopPropagation());
        // la miniatura sigue al color elegido
        sel.addEventListener('change', function (e) {
          e.stopPropagation();
          const img = $('[data-clook-img]', it);
          const url = sel.options[sel.selectedIndex].getAttribute('data-img');
          if (img && url) { img.src = url; }
        });
      }
      const link = $('.clook__name', it);
      if (link) link.addEventListener('click', (e) => e.stopPropagation());
    });
    btn.addEventListener('click', function () {
      const picks = selected().map((it) => ({ id: Number($('[data-clook-variant]', it).value), quantity: 1 }));
      if (!picks.length) return;
      btn.disabled = true; btnText.textContent = 'Agregando...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: picks })
      }).then((r) => r.json()).then(() => {
        btnText.textContent = '¡Agregado!';
        items.forEach((it) => { $('[data-clook-check]', it).checked = false; });
        refreshCart(true);
        setTimeout(sync, 1500);
      }).catch(() => { btnText.textContent = 'No se pudo agregar'; setTimeout(sync, 1800); });
    });
    root.addEventListener('clook:sync', sync);
    sync();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement(); initHero(); initGender(); initCarousels();
    initMobileMenu(); initCart(); initProduct(); initSort(); initCardSwatches();
    initDelivery(); initCompleteLook();
  });
})();
